// candidate profile sections and section fields
const hideablesDetailsListNested = [
    'name',
    'aliases',
    'picture',
    'links',
    'summary',
    {
        value: 'currentPosition',
        subValues: [
            'currentPositionJobTitle',
            'currentPositionPositionType',
            'currentPositionClassification',
            'currentPositionCompany',
            'currentPositionDepartment',
            'currentPositionIndustry',
            'currentPositionLocation',
            'currentPositionCompanyTypes',
            'currentPositionTeamSize',
            'currentPositionStartDate',
            'currentPositionEndDate',
            'currentPositionSummary',
            'currentPositionKeyAchievements',
            'currentPositionKeySkills',
        ],
    },
    {
        value: 'otherPositions',
        subValues: [
            'otherPositionsJobTitle',
            'otherPositionsPositionType',
            'otherPositionsClassification',
            'otherPositionsCompany',
            'otherPositionsDepartment',
            'otherPositionsIndustry',
            'otherPositionsLocation',
            'otherPositionsCompanyTypes',
            'otherPositionsTeamSize',
            'otherPositionsStartDate',
            'otherPositionsEndDate',
            'otherPositionsSummary',
            'otherPositionsKeyAchievements',
            'otherPositionsKeySkills',
        ],
    },
    {
        value: 'currentStatus',
        subValues: [
            'statusPositionType',
            'statusCareers',
            'statusClassification',
            'statusIndustries',
            'statusLocations',
            'statusCurrentStatus',
        ],
    },
    {
        value: 'aspirations',
        subValues: [
            'aspirationPositionType',
            'aspirationNED',
            'aspirationPermanent',
            'aspirationInterim',
            'aspirationCareers',
            'aspirationCompanyTypes',
            'aspirationIndustries',
            'aspirationLocations',
            'aspirationAdditional',
        ],
    },
    {
        value: 'confidential',
        subValues: [
            'confidentialSalary',
            'confidentialProbono',
            'confidentialNotice',
            'confidentialAdditional',
        ],
    },
    'education',
    'languages',
];

const hideablesDetailsList = hideablesDetailsListNested.flatMap(obj => {
    if (obj.subValues) {
        let values = [...obj.subValues];
        values.unshift(obj.value);
        return values;
    }
    return obj;
});

// unconnected candidate profile sections
const unconnectedDetailsSections = [
    'aspirations',
];
// candidate profile sections
const detailsSections = [
    'aliases',
    'picture',
    'links',
    'summary',
    'positions',
    'currentStatus',
    'aspirations',
    'confidential',
    'education',
    'languages',
];

export {
    detailsSections,
    hideablesDetailsList,
    hideablesDetailsListNested,
    unconnectedDetailsSections,
};